import { Extensions } from './Extensions'

export class InventoryExtensions extends Extensions {}
